<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Note on Translations and Citations">
<p class="fm_h" id="sec2"><span class="right_1" epub:type="pagebreak" id="page_xiii" title="xiii"><a href="#/text/Contents#rsec2">NOTE ON TRANSLATIONS AND CITATIONS</a></span></p>
<p class="noindent_para"><span class="dropcap">R</span><span class="smallcaps">EFERENCES TO THE</span> <i>R<span class="smallcaps">EPUBLIC</span></i> <span class="smallcaps">WILL BE INCLUDED IN</span> the text, identifying book and Stephanus pagination (e.g., I.343b); for quotations from the <i>Republic</i>, I have used Bloom’s translation throughout. For other works of Plato, the Stephanus pagination will be preceded by the title of the work. For the <i>Laws</i>, I quote Pangle’s translation; for the <i>Phaedo</i>, I quote the translation by Brann, Kalkavage, and Salem; and for the <i>Phaedrus</i>, I quote Scully’s translation. Unless otherwise indicated, all other translations of Plato are from <i>Collected Works</i>.</p>
<p class="indent_para">For the works of Aristotle, I have used the translations in <i>The Complete Works of Aristotle</i>, except for the <i>Nicomachean Ethics</i>, for which I have used the translation by Bartlett and Collins.<span class="right_1" epub:type="pagebreak" id="page_xiv" title="xiv"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Note.vue?c601e178